import { FunctionComponent, HTMLAttributes, useEffect, useRef } from 'react';

import { MWGameGridObserver } from '../MWGameGridObserver';

import styles from './GameGridContent.module.css';

export interface GameGridContentConnectedProps extends HTMLAttributes<HTMLDivElement> {}

export const GameGridContentConnected: FunctionComponent<GameGridContentConnectedProps> = ({
  children,
  className,
  ...rest
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    MWGameGridObserver.addMeasurer('content', () => {
      return {
        contentOffsetTop: contentRef.current?.offsetTop || null,
      };
    });
  }, []);

  return (
    <div className={`${styles.gameGridContent} ${className || ''}`} {...rest} ref={contentRef}>
      {children}
    </div>
  );
};
